import { createFileRoute } from "@tanstack/react-router";

import { enumParam } from "../../../lib/url-state";
import { useProjectId } from "../../../shell/project";
import { RobotPage } from "../../../workspaces/fleet/pages/RobotPage";
import { ROBOT_TABS, type RobotTab } from "../../../workspaces/fleet/robot-tab";

/** One deployed robot, by its station: its status on Overview; in 3D, driven and operated in VR,
 * on Operate (`?tab=operate`, so the headset can open straight there). */
export const Route = createFileRoute("/_console/p/$org/$project/deploy/$robot")({
  validateSearch: (search: Record<string, unknown>): { readonly tab?: RobotTab } => {
    const tab = enumParam(search.tab, ROBOT_TABS);
    return tab === "operate" ? { tab } : {};
  },
  component: RobotRoute,
});

function RobotRoute() {
  const { robot } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <RobotPage
      projectId={useProjectId()}
      stationId={robot}
      tab={tab}
      onTab={(next) => void navigate({ search: next === "operate" ? { tab: next } : {} })}
    />
  );
}
